import { pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core';

import { SUPPORTED_INTERVIEW_LANGUAGES } from '@kiku/config/constants';

import { tenantIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const organizations = pgTable(
  'organizations',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    name: text('name').notNull(),
    slug: text('slug').notNull(),
    language: text('language', { enum: SUPPORTED_INTERVIEW_LANGUAGES }).notNull().default('en'),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    uniqueIndex('organizations_tenant_slug_unique').on(t.tenantId, t.slug),
    tenantIsolationPolicy()
  ]
).enableRLS();
